import MockAdapter from 'axios-mock-adapter';
import { api } from '@services/api';
import { registerMockHandlers } from './handlers';

export async function initMocks(): Promise<void> {
  const mock = new MockAdapter(api, { delayResponse: 200, onNoMatch: 'passthrough' });
  registerMockHandlers(mock);

  console.info('[mocks] axios-mock-adapter initialized');
}

export { dashboardTemplates } from './data/templates';
